import { Dispatch } from "redux";
import { setCustomDomainData } from "../redux/customDomain";
import { oauth } from "../utils";

export const getCustomDomainStatus =
  (shop_id: string) => async (dispatch: Dispatch<any>) => {
    try {
      const { json } = await oauth("GET", "custom-domain-status", { shop_id });
      dispatch(setCustomDomainData(json));
      return json;
    } catch (err: any) {
      if (err?.response?.status === 404 || err?.status === 404) {
        dispatch(setCustomDomainData(null));
      }
      return null;
    }
  };

export const createCustomDomain =
  (shop_id: string, url: string) => async (dispatch: Dispatch<any>) => {
    try {
      const { json } = await oauth("POST", "custom-domains", {
        shop_id,
        url,
      });
      dispatch(
        setCustomDomainData({
          customDomainUrl: url,
          isActive: false,
          domainStatus: json.status,
          ownershipVerification: json.ownershipVerification,
        }),
      );
      return json;
    } catch (err: any) {
      dispatch(setCustomDomainData(null));
      throw err;
    }
  };

export const deleteCustomDomain =
  (shop_id: string, unregisterDomain: boolean = false) =>
  async (dispatch: Dispatch<any>) => {
    try {
      await oauth("DELETE", "custom-domains", {
        shop_id,
        should_unregister_domain: unregisterDomain,
      });
      dispatch(setCustomDomainData(null));
    } catch (err: any) {
      throw err;
    }
  };
